import React from "react";
import { NavLink } from "react-router-dom";
import styled from "styled-components";
import { lighten } from "polished";

export const NAV_HEIGHT = 47;

const StyledNav = styled.div`
  padding: 0.5rem;
  width: 100%;
  position: fixed;
  z-index: 2;
  top: 0;
  background: ${(props) => props.theme.colors.white};
  height: ${NAV_HEIGHT}px;

  li {
    display: inline-block;
    margin-right: 0.75rem;
    &:last-child {
      position: absolute;
      right: 0;
    }
  }

  a {
    border-radius: 20px;
    text-align: left;
    display: block;
    padding: 0.4rem 1rem;
    color: ${(props) => props.theme.colors.black};
    user-select: none;
    text-decoration: none;

    &.active {
      background: ${(props) => props.theme.colors.black};
      color: white;
    }

    &:hover:not(.active) {
      background: ${(props) => lighten(0.15, props.theme.colors.gray1)};
    }
  }
`;

let MAIN_MENU = [
  {
    path: "/recording",
    name: "Recorder",
  },
  {
    path: "/interactive-bus",
    name: "Interactive bus",
  },
  {
    path: "/library",
    name: "Library",
  },
  {
    path: "/services",
    name: "Services",
  },
  {
    path: "/push-logs",
    name: "Push logs",
  },
  {
    path: "/logout",
    name: "Logout",
  },
];

if (process.env.REACT_APP_ENABLE_PUSH_LOGS !== "true")
  MAIN_MENU = MAIN_MENU.filter((menu) => menu.path !== "/push-logs");

const Nav = () => {
  return (
    <StyledNav>
      <nav>
        <ul>
          {MAIN_MENU.map(({ name, path }) => (
            <li key={name}>
              <NavLink to={path} activeClassName="active">
                {name}
              </NavLink>
            </li>
          ))}
        </ul>
      </nav>
    </StyledNav>
  );
};

export default Nav;
